<!-- eslint-disable prettier/prettier -->
<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="aulaSelecionada.voltar"
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulas',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green" class="mb-5" outlined>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <h4>Disciplina: {{ gestaoDeAula.disciplina.descricao }}</h4>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[NÃO INFORMADO]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ValidationObserver v-if="etapas" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="6" v-if="etapas?.length">
            <ValidationProvider name="Etapa" rules="required" v-slot="{ errors }">
              <div class="mb-4">
                <e-label>
                  Etapas
                  <v-chip
                    small
                    v-if="etapaSelecionada?.periodo_extensao"
                    class="text-none"
                    :color="getChipColor(etapaSelecionada?.periodo_extensao)"
                  >
                    Extendido até: {{ dateFormatConvert(etapaSelecionada?.periodo_extensao) }}
                  </v-chip>
                </e-label>
              </div>

              <e-autocomplete
                id="aulaSelecionada.etapa"
                v-if="editing"
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item?.descricao} - Início: ${dateFormatConvert(
                      item?.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
              />

              <e-autocomplete
                id="aulaSelecionada.etapa"
                v-else
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item?.descricao} - Início: ${dateFormatConvert(
                      item?.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col>
            <v-btn
              id="aulaSelecionada.solicitar-autorizacao"
              v-if="etapaBloqueada == true && etapaPendente == false"
              style="box-shadow: none"
              color="success"
              class="text-none mt-8"
              @click="() => criarPedido(etapaSelecionada.id)"
              >Solicitar Autorização</v-btn
            >
          </v-col>
        </v-row>
        <div v-if="etapaSelecionada && etapaBloqueada == false">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12">
              <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
                <e-label>Tipo de aula</e-label>
                <e-autocomplete
                  id="aulaSelecionada.tipo_de_aula"
                  :items="$constants.tiposDeAulas"
                  :return-object="false"
                  :error-messages="errors"
                  v-model="aulaSelecionada.tipo_de_aula"
                  @change="() => verificaTipoDaAula()"
                  label="Selecione um tipo de aula"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col class="pt-0 pb-0" cols="6">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="data"
                persistent
                width="450px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <e-label>Selecione uma data</e-label>
                  <v-text-field
                    id="aulaSelecionada.data"
                    v-model="aulaSelecionada.data"
                    persistent-hint
                    :disabled="aulaSelecionada.tipo_de_aula ? false : true"
                    label="Escolha uma data"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    solo
                  ></v-text-field>
                </template>

                <v-card>
                  <v-container class="calendar-container">
                    <v-row>
                      <!-- Calendário -->
                      <v-col cols="12" md="12" class="d-flex justify-center">
                        <v-card class="calendar-card pa-3" elevation="2" outlined>
                          <v-date-picker
                            v-model="data"
                            full-width
                            scrollable
                            :min="inicioPeriodoEtapa"
                            :max="fimPeriodoEtapa"
                            :allowed-dates="allowedDates"
                            :events="todosEventos.map((e) => e.data)"
                            :event-color="getBadgeColor"
                            @update:picker-date="atualizarMesVisivel"
                            color="primary"
                            header-color="primary"
                          >
                            <template v-slot:day="{ date, day }">
                              <v-badge
                                :color="getBadgeColor(date)"
                                :content="getBadgeContent(date)"
                                overlap
                                dot
                              >
                                <span :class="{ 'font-weight-bold': isToday(date) }">{{
                                  day
                                }}</span>
                              </v-badge>
                            </template>
                          </v-date-picker>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <!-- Lista de eventos -->
                      <v-col cols="12" md="12">
                        <v-card class="events-card" elevation="2" outlined>
                          <v-card-title class="primary white--text pa-4">
                            <v-icon left color="white">mdi-calendar-month</v-icon>
                            Eventos do Mês
                          </v-card-title>

                          <v-divider></v-divider>

                          <v-list dense class="py-0">
                            <template v-for="(evento, index) in eventosFiltradosPorMes">
                              <v-divider v-if="index > 0" :key="`divider-${index}`"></v-divider>
                              <!-- {{ evento }} -->
                              <v-list-item class="px-4" :key="`evento-${index}`">
                                <v-list-item-icon class="mr-3">
                                  <v-icon :color="evento.cor">mdi-circle-small</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title class="d-flex align-center">
                                    <span class="date-label mr-2">{{
                                      formatarDia(evento.data)
                                    }}</span>
                                    <span>
                                      {{ evento.descricao }}
                                      <v-chip
                                        v-if="
                                          evento.is_sabado_letivo === true ||
                                          evento.is_sabado_letivo === 1
                                        "
                                        x-small
                                        color="green"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Dia Letivo
                                      </v-chip>
                                      <v-chip
                                        v-else
                                        x-small
                                        color="red"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Dia não letivo
                                      </v-chip>
                                    </span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>

                            <v-list-item v-if="eventosFiltradosPorMes.length === 0">
                              <v-list-item-content>
                                <v-list-item-title class="text-caption grey--text">
                                  Nenhum evento neste mês
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-btn id="aulaSelecionada.data-cancelar" text color="primary" @click="modal = false">Cancelar</v-btn>
                    <v-btn id="aulaSelecionada.data-ok" text color="primary" @click="$refs.dialog.save(data)">OK</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                <e-label>Selecione um horário</e-label>
                <e-autocomplete
                  id="aulaSelecionada.horario"
                  :disabled="aulaSelecionada.data ? false : true"
                  :items="horarios"
                  :error-messages="errors"
                  label="Selecione uma opção"
                  :item-text="(item) => item.descricao"
                  v-model="horarioSelecionado"
                  return-object
                  dense
                  clearable
                  @change="() => pesquisaAulas()"
                />
              </ValidationProvider>
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Dia da semana</e-label>
              <v-text-field solo dense v-model="aulaSelecionada.dia_da_semana" :disabled="true">
              </v-text-field>
            </v-col>

            <div v-if="outrosCampos">
              <v-col cols="12"> </v-col>
              <v-col class="pt-0 pb-0" cols="12">
                <h4>Campos de experiências</h4>
                <v-row class="">
                  <v-col class="pt-0 pb-0" cols="4" v-for="(el, index) of opcoes" :key="index">
                    <v-checkbox
                      v-model="campos_de_experiencias[index]"
                      :label="el"
                      :value="el"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>

              <v-col
                cols="12"
                v-if="
                  horarioSelecionado || aulaSelecionada.tipo_de_aula === 'Aula Remota' || editing
                "
              >
                <!-- <ValidationProvider name="conteudo" rules="required" v-slot="{ errors }">
                <e-label>Eixos temáticos</e-label>
                <v-textarea solo dense v-model="aulaSelecionada.eixos" :error-messages="errors" />
              </ValidationProvider> -->

                <ValidationProvider
                  name="estrategias"
                  rules="required|max:4000"
                  v-slot="{ errors }"
                >
                  <e-label>Estratégias de ensino </e-label>
                  <v-textarea
                    id="aulaSelecionada.estrategias"
                    solo
                    dense
                    v-model="aulaSelecionada.estrategias"
                    :error-messages="errors"
                    :maxlength="4000"
                    :counter="true"
                  >
                    <template v-slot:counter>
                      {{ (aulaSelecionada.estrategias || "").length }}/4000
                    </template>
                  </v-textarea>
                </ValidationProvider>

                <ValidationProvider name="recursos" rules="required|max:4000" v-slot="{ errors }">
                  <e-label>Recursos</e-label>
                  <v-textarea
                    id="aulaSelecionada.recursos"
                    solo
                    dense
                    v-model="aulaSelecionada.recursos"
                    :error-messages="errors"
                    :maxlength="4000"
                    :counter="true"
                  >
                    <template v-slot:counter>
                      {{ (aulaSelecionada.recursos || "").length }}/4000
                    </template>
                  </v-textarea>
                </ValidationProvider>

                <!-- <ValidationProvider name="atividade_classe" rules="required" v-slot="{ errors }">
                <e-label>Atividade de classe</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.atividade_classe"
                  :error-messages="errors"
                />
              </ValidationProvider> -->

                <ValidationProvider
                  name="atividade_casa"
                  rules="required|max:4000"
                  v-slot="{ errors }"
                >
                  <e-label>Atividade de casa</e-label>
                  <v-textarea
                    id="aulaSelecionada.atividade_casa"
                    solo
                    dense
                    v-model="aulaSelecionada.atividade_casa"
                    :error-messages="errors"
                    :maxlength="4000"
                    :counter="true"
                  >
                    <template v-slot:counter>
                      {{ (aulaSelecionada.atividade_casa || "").length }}/4000
                    </template>
                  </v-textarea>
                </ValidationProvider>

                <ValidationProvider name="Observações" rules="max:4000" v-slot="{ errors }">
                  <e-label>Observações</e-label>
                  <v-textarea
                    id="aulaSelecionada.observacoes"
                    solo
                    dense
                    v-model="aulaSelecionada.observacoes"
                    :error-messages="errors"
                    rule
                    :maxlength="4000"
                    :counter="true"
                  >
                    <template v-slot:counter>
                      {{ (aulaSelecionada.observacoes || "").length }}/4000
                    </template>
                  </v-textarea>
                </ValidationProvider>

                <v-btn
                  id="aulaSelecionada.submit"
                  color="primary"
                  :disabled="submittingForm"
                  :loading="submittingForm"
                  type="submit"
                  >Enviar Dados</v-btn
                >
                <v-btn
                  id="aulaSelecionada.duplicar"
                  v-if="editing"
                  class="ml-3"
                  color="success"
                  @click="dialog.duplicar = true"
                  >Duplicar Aula</v-btn
                >
                <v-btn
                  id="aulaSelecionada.exportar"
                  v-if="editing"
                  class="ml-3"
                  color="success"
                  @click="dialog.exportar = true"
                  >Exportar Aula</v-btn
                >
              </v-col>
            </div>
          </v-row>
        </div>
        <v-row v-if="etapas?.length === 0 && etapaBloqueada == false">
          <v-col cols="12">
            <v-alert type="warning" border="left">
              Não existem etapas disponíveis para a data atual
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaBloqueada == true && etapaPendente == false">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Atenção essa etapa está bloqueada, para lançar aulas você deve solicitar uma
              autorização, clicando no botão acima
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaPendente == true">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Aguarde, já existe um pedido de autorização para essa etapa e estamos analisando.
            </v-alert>
            <v-btn id="aulaSelecionada.ver-pedidos" class="success" @click="verPedidos">Acompanhe seus pedidos</v-btn>
          </v-col>
        </v-row>

        <div v-if="etapas?.length > 0 && etapaBloqueada == false && etapaSelecionada">
          <v-row
            v-if="!aulaSelecionada.tipo_de_aula || !aulaSelecionada.data || !horarioSelecionado"
          >
            <v-col cols="12" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
              <v-alert type="warning" border="left"> Por favor, preencha todos os campos! </v-alert>
            </v-col>
          </v-row>
        </div>
      </form>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn id="aulaSelecionada.fechar-conflitos" color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
            Fechar
          </v-btn>

          <h2 class="mt-4">Aulas conflitadas</h2>

          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="item in aulasConflitadas" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.professor.nome }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ item.turma.franquia.descricao }}
                    </v-chip>
                  </td>
                  <td>{{ item.situacao ? item.situacao : "Aguardando" }}</td>
                  <td>
                    <span>
                      {{ item.data.split("-").reverse().join("/") }}
                    </span>
                    - {{ item.horario.descricao }}
                  </td>
                  <td>{{ item.turma.descricao }}</td>
                  <td>{{ item.disciplina.descricao }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>
    <v-alert text border="left" color="orange" icon="warning" class="text-caption" v-else
      >Atenção, essa turma ainda não foi vinculada a um circuito, para fazer isso você tem que ir em
      Turmas->Editar e Selecione o Circuito desejado, caso seja um professor aguarde o responsável
      realizar esse procedimento.</v-alert
    >

    <!-- <e-modal-duplicar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      :horarios="horarios"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula> -->
    <e-modal-duplicar-aula-infantil
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      :horarios="horarios"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula-infantil>
    <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";
import { dateFormatParam } from "../../plugins/filters";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    aula_id: {
      type: Number,
      require: true,
    },
  },
  computed: {
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
    eventosFiltradosPorMes() {
      if (!this.mesVisivel) return [];
      return (this.todosEventos || [])
        .filter((evento) => evento.data.startsWith(this.mesVisivel))
        .sort((a, b) => {
          return parseInt(a.data.split("-")[2], 10) - parseInt(b.data.split("-")[2], 10);
        });
    },
  },
  async mounted() {
    await this.buscarTodosHorarios();
    this.loadData();
    await this.carregarFeriados();

    if (this.editing) {
      this.mostrarCampos = true;
      this.outrosCampos = true;
    }
  },
  data() {
    return {
      opcoes: [
        "O eu, o outro e o nós",
        "Corpo, gestos e movimentos",
        "Escuta, fala, pensamento e imaginação",
        "Traços, sons, cores e formas",
        "Espaço, tempo, quantidades, relações e transformações",
      ],
      data: null,
      modal: false,
      menu: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      diasSemana: this.$constants.diasDaSemana,
      mostrarCampos: true,
      outrosCampos: false,
      submittingForm: false,
      form: {},
      experiencias: [],
      campos_de_experiencias: [],
      aulaSelecionada: {
        data: null,
        dia_da_semana: "",
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      aulaDuplicada: {},
      gestaoDeAulas: null,
      dialog: {
        duplicar: false,
        exportar: false,
      },
      horarios: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      diasPermitidosParaCriarAula: [0, 1, 2, 3, 4, 5, 6],
      mesVisivel: null,
      feriados: [],
      sabadosLetivos: [],
      eventosQueBloqueiamAulas: [],
      avisoAnime: "",
      etapaPendente: false,
      etapaBloqueada: false,
      idsEtapasDisponivels: [],
      idsEtapasPendentes: [],
      autorizacao: [],
      mostrarEtapas: false,
      fimPeriodoEtapa: null,
      inicioPeriodoEtapa: null,
      etapaSelecionada: null,
      etapas: null,
      turma: null,
      carregandoDados: false,
      todosEventos: [],
    };
  },
  watch: {
    tipo_de_aula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = null;
      }
    },
    data(value) {
      if (!value) return;
      const data_old = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));
      this.aulaSelecionada.data = data_old.replaceAll("/", "/");

      const diaDaSemana = new Date(value).getDay();
      this.diaDaSemana();
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana, value).then(() => {
        if (this.editing && this.horarioSelecionado) {
          const horarioAtual = this.horarios.find((h) => h.id === this.horarioSelecionado.id);
          if (horarioAtual) {
            this.horarioSelecionado = horarioAtual;
          }
        }
      });
    },
  },
  methods: {
    async filtrarHorariosPorDiaDaSemana(diaDaSemana, dataSelecionada = this.data) {
      const toYMD = (v) => {
        if (!v) return "";
        if (typeof v === "string") return v.length > 10 ? v.slice(0, 10) : v;
        const d = v instanceof Date ? v : new Date(v);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
          d.getDate()
        ).padStart(2, "0")}`;
      };

      const dataFormatada = toYMD(dataSelecionada);
      const eventos = this.todosEventos || [];
      const evento = eventos.find((ev) => toYMD(ev.data) === dataFormatada);

      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          if (!this.todosHorariosDisponiveis || this.todosHorariosDisponiveis.length === 0) {
            await this.buscarTodosHorarios();
          }
          this.horarios = this.todosHorariosDisponiveis || [];
          this.horariosDoComponente = this.todosHorariosDisponiveis || [];
          return;
        }
        this.horarios = [];
        this.horariosDoComponente = [];
        return;
      }

      if (!this.gestaoDeAula?.relacoesDiasHorarios) {
        this.horarios = [];
        this.horariosDoComponente = [];
        return;
      }

      const horariosDoDia = this.gestaoDeAula.relacoesDiasHorarios
        .filter((relacao) => relacao.dia.id === diaDaSemana)
        .map((relacao) => relacao.horario);

      this.horarios = horariosDoDia;
      this.horariosDoComponente = horariosDoDia;
    },

    async pesquisaAulas() {
      const data_aula = this.aulaSelecionada.data.split("/").reverse().join("-");
      // /* eslint-disable */
      const { aula_id } = this.$route.params;
      const horario_id = this.horarioSelecionado.id;
      const turma_id = this.gestaoDeAula.turma.id;
      if (!data_aula || !this.horarioSelecionado || !this.aulaSelecionada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
        data_aula,
        horario_id,
        turma_id,
        aula_id
      );

      if (response.data?.length === 0) {
        this.mostrarCampos = true;
        this.outrosCampos = true;
      } else {
        this.aulasConflitadas = response.data;
        this.aulasEmConflitos = true;
        this.outrosCampos = false;
      }
    },

    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        this.outrosCampos = true;
        return;
      }
      await this.getHorarios();

      this.mostrarCampos = true;
      this.outrosCampos = false;
    },
    async formatarCamposDeExperiencia() {
      try {
        const data = [];
        this.opcoes.forEach((opcao, index) => {
          const matches = this.campos_de_experiencias.filter((experiencia) => {
            return experiencia ? experiencia.trim() === opcao.trim() : false;
          });
          const dado = matches.length > 0 ? matches[0] : null;
          this.experiencias.push(dado ?? null);
        });
        this.campos_de_experiencias = this.experiencias;
      } catch (e) {
        this.$handleError(e);
      }
    },
    async submitForm() {
      this.aulaSelecionada.e_aula_infantil = 1;
      this.aulaSelecionada.campos_de_experiencias = this.campos_de_experiencias;
      this.aulaSelecionada.horario_inicial = this.horarioSelecionado
        ? this.horarioSelecionado.inicio
        : null;
      this.aulaSelecionada.horario_final = this.horarioSelecionado
        ? this.horarioSelecionado.final
        : null;
      this.aulaSelecionada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
      this.aulaSelecionada.etapa_id = this.etapaSelecionada.id;

      this.submittingForm = true;
      try {
        if (this.editing) {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasService.atualizar(this.aulaSelecionada);
          this.$toast.success("Aula editada com sucesso!");
        } else {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.disciplina_id = this.gestaoDeAula.disciplina_id;
          this.aulaSelecionada.turma_id = parseInt(this.gestaoDeAula.turma_id, 10);
          this.aulaSelecionada.instrutor_id = parseInt(this.gestaoDeAula.instrutor_id, 10);
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasService.criarAula(this.aulaSelecionada);
          this.$toast.success("Aula cadastrada com sucesso!");
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
      this.$router.push({
        name: "aulas",
      });
    },
    async getAula() {
      await this.getHorarios();
      const { aula_id } = this.$route.params;
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );
      this.gestaoDeAula = response.payload.gestaoDeAula;
      const turnoIdTurma = this.gestaoDeAula.turma?.turno_id;

      this.horariosSabado = response.payload.horarios.filter((h) => h.turno_id === turnoIdTurma);
      const aulaSelecionada = await this.$services.aulasService.getAula(parseInt(aula_id, 10));

      this.horarioSelecionado = aulaSelecionada.horario ?? null;
      this.campos_de_experiencias = aulaSelecionada.campos_de_experiencias
        ? aulaSelecionada.campos_de_experiencias
        : [];
      await this.formatarCamposDeExperiencia();

      this.aulaSelecionada.data = aulaSelecionada.data;
      this.data = aulaSelecionada.data;
      const diaSemana = new Date(this.data).getDay();
      this.filtrarHorariosPorDiaDaSemana(diaSemana);

      if (this.gestaoDeAula.relacoesDiasHorarios) {
        this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
          (g) => g.dia.id
        );

        this.horarios = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);
      }

      return aulaSelecionada;
    },
    async loadData() {
      try {
        this.carregandoDados = true;
        this.$loaderService.open("Carregando dados...");
        await this.buscarTodosHorarios();
        await this.getHorarios();
        this.aulaSelecionada = await this.getAula();
        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }
        if (this.turma.circuito_nota_id) {
          const response = await this.$services.etapasService.syncAllEtapasDisponiveis(
            this.turma.circuito_nota_id,
            this.$route.params.gestaoDeAulaId
          );
          this.etapas = response.etapas;
          this.idsEtapasDisponivels = response.disponiveis;

          this.etapas.forEach((element) => {
            this.verificarSeTemPedido(element.id);
          });

          if (this.editing) {
            this.getEtapa();
          }
        }
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
      this.carregandoDados = false;
    },
    diaDaSemana() {
      const data_do_usuario = this.aulaSelecionada.data;
      const data_do_usuario_formatada = data_do_usuario.replace(/\//g, "-");
      const array1 = data_do_usuario_formatada.split("-");
      const array2 = array1.reverse();
      const data_final = new Date(array2[0], parseInt(array2[1], 10) - 1, array2[2]);
      const dia = this.diasSemana[data_final.getDay()];
      this.aulaSelecionada.dia_da_semana = dia;
    },
    async getHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
          this.$route.params.gestaoDeAulaId
        );
        this.turma = response.payload.gestaoDeAula.turma;
        this.gestaoDeAula = response.payload.gestaoDeAula;

        const turnoIdTurma = this.gestaoDeAula.turma?.turno_id;

        await this.buscarTodosHorarios();

        this.horariosSabado = response.payload.horarios
          .filter((h) => h.turno_id === turnoIdTurma)
          .map((h) => ({
            id: h.id,
            turno_id: h.turno_id,
            descricao: h.descricao.split(" - ")[0],
            final: h.final,
            inicio: h.inicio,
          }));

        if (this.gestaoDeAula.relacoesDiasHorarios) {
          this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
            (g) => g.dia.id
          );

          this.horariosDaGestao = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);
          this.horarios = this.horariosDaGestao;
        }
      } catch (error) {
        this.$toast.error("Erro ao carregar informações de horários");
      }
    },
    allowedDates(val) {
      let dataFormatada;
      if (typeof val === "string") {
        dataFormatada = val.length > 10 ? val.slice(0, 10) : val;
      } else {
        dataFormatada = new Date(val).toISOString().split("T")[0];
      }

      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === dataFormatada;
      });
      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          return true;
        }
        return false;
      }
      const ehFeriado = this.feriados.some((feriado) => {
        const fData = feriado.data.length > 10 ? feriado.data.slice(0, 10) : feriado.data;
        return fData === dataFormatada;
      });
      if (ehFeriado) return true;

      const diaDaSemana = new Date(dataFormatada).getDay();
      if (!this.diasPermitidosParaCriarAula.includes(diaDaSemana)) return false;

      return true;
    },
    async carregarFeriados() {
      try {
        const response = await this.$services.calendarioLetivoService.syncAll();

        this.todosEventos = response.map((evento) => ({
          data: evento.start,
          descricao: evento.descricao,
          cor: evento.color,
          is_feriado: evento.evento.is_feriado,
          is_sabado_letivo: evento.evento.is_sabado_letivo,
        }));
        this.feriados = this.todosEventos.filter((evento) => evento.is_feriado === true);
        this.sabadosLetivos = this.todosEventos.filter(
          (evento) => evento.is_sabado_letivo === true
        );
      } catch (error) {
        this.$handleError(error);
      }
    },
    atualizarMesVisivel(pickerDate) {
      const [ano, mes] = pickerDate.split("-");
      this.mesVisivel = `${ano}-${mes}`;
    },
    formatarDia(data) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}`;
    },
    getEventColor(date) {
      const cores = [];
      const feriado = this.feriados.find((f) => f.data === date);
      if (feriado) cores.push(feriado.cor);
      const sabado = this.sabadosLetivos.find((s) => s.data === date);
      if (sabado) cores.push(sabado.cor);
      return cores.length > 0 ? cores : "red";
    },
    animarAviso() {
      this.avisoAnime = "animate__animated animate__headShake";
      setTimeout(() => (this.avisoAnime = ""), 500);
    },
    dateFormatConvert(data) {
      return dateFormatParam(data);
    },
    verificarEtapaSelecionada() {
      this.animarAviso();
      this.inicioPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada.id)
        .shift().periodo_inicial;
      this.inicioPeriodoEtapa = dateFormatParam(this.inicioPeriodoEtapa, "y-m-d");
      this.fimPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada.id)
        .shift().periodo_final;
      this.fimPeriodoEtapa = dateFormatParam(this.fimPeriodoEtapa, "y-m-d");

      const etapaVerificar = this.etapas.filter((d) => d.id === this.etapaSelecionada.id).shift();

      this.verificarSeEtapaEstaDisp(etapaVerificar);
    },
    getEtapa() {
      let etapa = this.etapas.filter((d) => d.id === this.aulaSelecionada.etapa_id);
      etapa = etapa.shift();
      this.fimPeriodoEtapa = etapa.periodo_final;
      this.inicioPeriodoEtapa = etapa.periodo_inicial;
      this.etapaSelecionada = etapa;
    },
    criarPedido(etapaId) {
      this.$router.push({ name: "autorizacoes.create", params: { etapa: etapaId } });
    },
    verPedidos() {
      this.$router.push({ name: "autorizacoes" });
    },
    verificarSeEtapaEstaDisp(etapa) {
      if (this.idsEtapasDisponivels.includes(etapa.id)) {
        this.etapaBloqueada = false;
      } else {
        this.etapaBloqueada = true;
      }
      if (this.idsEtapasPendentes.includes(etapa.id)) {
        this.etapaPendente = true;
      } else {
        this.etapaPendente = false;
      }
    },
    async verificarSeTemPedido(etapaId) {
      const response = await this.$services.autorizacoesService.verificarPedidosDeferidos(etapaId);

      if (response.data.aprovados.length) {
        this.idsEtapasDisponivels.push(etapaId);
      }

      if (response.data.pendentes.length) {
        this.idsEtapasPendentes.push(etapaId);
      }
    },
    getChipColor(dataExtensao) {
      if (!dataExtensao) return "primary";
      const hoje = new Date();
      const dataExt = new Date(dataExtensao);

      hoje.setHours(0, 0, 0, 0);
      dataExt.setHours(0, 0, 0, 0);

      if (dataExt >= hoje) {
        return "green";
      }
      return "red";
    },
    async buscarTodosHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.getAllHorarios();

        const horariosData = response.data || response;
        this.todosHorariosDisponiveis = horariosData.map((h) => ({
          id: h.id,
          turno_id: h.turno_id,
          descricao: h.descricao ? h.descricao.split(" - ")[0] : "Horário",
          final: h.final,
          inicio: h.inicio,
        }));

        return this.todosHorariosDisponiveis;
      } catch (error) {
        this.$handleError(error);
        return [];
      }
    },
    getBadgeColor(date) {
      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === date;
      });
      if (evento) {
        return (
          evento.cor ||
          (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1 ? "green" : "red")
        );
      }
      if (this.isFeriado(date)) return "red";
      return "";
    },
    getBadgeContent(date) {
      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === date;
      });
      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          return "Letivo";
        }
        return "Dia não letivo";
      }
      if (this.isFeriado(date)) return "F";
      return "";
    },
    isFeriado(date) {
      return this.feriados.some((f) => f.data === date);
    },
    isSabadoLetivo(date) {
      return this.sabadosLetivos.some((s) => s.data === date);
    },
    toYMD(v) {
      if (!v) return "";
      if (typeof v === "string") return v.length > 10 ? v.slice(0, 10) : v;
      const d = v instanceof Date ? v : new Date(v);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.dataInput {
  background-color: white;
  width: 100%;
  height: 35px;
  box-shadow: 2px 2px rgb(0, 0, 0, 0.1);
}
</style>
